<div class="contenedor">
  <div style="text-align: center;">
    <h2>
      Actualizar facturas {{mes>1?("últimos"):("último")}}  <br><span>{{mes}} {{mes>1?("meses"):("mes")}} </span>:
    </h2>
  </div>
  <div style="text-align: center; align-content: center; margin: 20px;">
    <!-- <form [formGroup]="formMeses"> -->
      <mat-slider min="1" max="6" step="1" showTickMarks discrete [displayWith]="formatLabel"  style="width:80%;">
        <input matSliderThumb [(ngModel)]="mes">
      </mat-slider>
      <!-- <mat-form-field style="width: 90px; height: 68px !important;">
        <mat-label>Meses</mat-label>
       
        <mat-select #select formControlName="meses">
          <mat-option
            *ngFor="let mes of meses"
            [value]="mes"
          >
            {{ mes }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
    <!-- </form> -->
    <button mat-stroked-button color="primary" (click)="updateInvoceCompany()" style="display: block; margin:auto">
      Actualizar
    </button>
  </div>
</div>